<div id="content" class="main-content">
    <div class="container">
        <div class="page-header ">
            <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between ">
                <h2><i class="flaticon-calendar-1"></i><b> Les absences</b></h2>
                <div class="alert alert-gradient alert-danger" 
                    id="leave_updated" role="alert" style="z-index: 9;position: absolute;display: none;right: 0; width: fit-content;
                    position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
                    <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                    <strong>La demande d'absence</strong>{{msg}}
                </div>
                <div class="alert alert-gradient alert-danger" 
                    id="leave_not_updated" role="alert" style="z-index: 9;position: absolute;display: none;right: 0; width: fit-content;
                    background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
                    <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
                    <strong>La modification a échouée!</strong>{{msg}}
                </div>
            </div>
        </div>
        <div>
            <div class="row"  style="justify-content: end;">
                <div>
                    <a type="button" class="btn btn-gradient-dark ml-2 mb-2 btn-rounded btn_new_customer" href="/absence-req" >
                        <i class="flaticon-plus-1 mr-2"></i> Demande d’absence
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col col-lg-12">
                    <div class="row" id="cancel-row" >
                        <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                            <div class="statbox widget box box-shadow">
                                <div class="widget-header">
                                    <div class="row">       
                                    </div>
                                </div>
                                <div class="widget-content widget-content-area pl-0 pr-1">
                                    <div *ngIf="updateLeaveLoading" class="cp-spinner cp-bubble" style="margin-top: 15%;margin-left: 49%;position: absolute;z-index: 9;"></div>
                                    <div *ngIf="absenceLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                                    <div  *ngIf="!absenceLoading" class="table-responsive mb-4">
                                        <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                            <thead>
                                              <tr>
                                                <th *ngIf="role == 'adm'"></th>
                                                <th *ngIf="role == 'adm'">Nom complet</th>
                                                <th>Type de l’absence</th>
                                                <th>La date de début de l’absence</th>
                                                <th>La date de fin de l’absence</th>
                                                <th>Le nombre des jours de l'absence</th>
                                                <th>Le motif de l’absence</th>
                                                <th>Le statut de la demande</th>
                                                <th>Actions</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr *ngFor="let absence of absence">
                                                <td *ngIf="role == 'adm'">
                                                    <img class="border-basic" [src]="absence.avatar ? 'data:image/jpeg;base64,' + absence.avatar : '../../assets/img/unknown_user.jpg'" alt="User Avatar" style="width: 50px; height: 50px; border-radius: 50px;">
                                                </td>                                                                                               
                                                <td *ngIf="role == 'adm'">
                                                    <span >{{ absence.fullname ||'----' }}</span>
                                                </td>
                                                <td>
                                                    <a [attr.href]="'absence-detail/' + absence.id"><span ><b>{{ absence.type ||'----' }}</b></span></a>
                                                </td>
                                                <td>
                                                    <span >{{ absence.start ||'----' }}</span>
                                                </td>
                                                <td>
                                                    <span >{{ absence.finish ||'----' }}</span>
                                                </td>
                                                <td>
                                                    <span >{{ absence.effectiveDays ||'----' }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ (absence.reason || '----').substring(0, 35) + (absence.reason.length > 35 ? '...' : '') }}</span>
                                                </td>
                                                <td>
                                                    <span>{{ getStatusText(absence.status) || '----' }}</span>
                                                </td>                                                
                                                <td class="text-center">
                                                    <div class="dropdown custom-dropdown" 
                                                        [ngClass]="{'disabled': (role != 'adm' && role != 'cmrc') || (role == 'cmrc' && absence.status != 1) || (role == 'adm' && (absence.status == 7 || absence.status == 2 ))}">
                                                        <a (click)="selectLeave(absence)" class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                            <i class="flaticon-dot-three"></i>
                                                        </a>
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1" *ngIf="absence.status != 7 && absence.status != 2">
                                                            <a *ngIf="role == 'adm' && absence.status != 3" class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#acceptLeave">Valider</a>
                                                            <a *ngIf="role == 'adm' && absence.status != 4" class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#rejectLeave">Refuser</a>
                                                            <a *ngIf="absence.status == 1 && editable(absence)" class="dropdown-item" [attr.href]="'absence-update/' + absence.id">Modifier</a>
                                                            <a *ngIf="role == 'cmrc' && absence.status == 1" class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#cancelLeave">Annuler</a>
                                                        </div>
                                                    </div>
                                                </td>                                                
                                              </tr>
                                            </tbody>
                                          </table>
                                    </div> 
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<div id="cancelLeave" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="widget-content-area  data-widgets br-4">
                <div class="widget">
                    <div class="media" style="display:block">
                        <div class="icon ml-2" style="text-align: center;">
                            <i class="flaticon-cancel-2 text-danger" style="font-size: xxx-large;"></i>
                        </div>
                        <div style="text-align: center; margin-top: 10%;">
                            <b>Êtes-vous sûr de vouloir annuler cette demande d'absence?</b>
                        </div>
                        <div style="margin-top:5%">
                            <div class="mt-6 text-center">
                                <button class="btn btn-danger btn-rounded mb-0 mt-4 mr-2" (click)="update(selectedAbsence, 'cancel')" 
                                    data-dismiss="modal">Annuler la demande</button>
                            </div>
                            <div class="mt-3 text-center">
                                <button class="btn btn-default btn-rounded mt-0 mb-0" data-dismiss="modal">Retour</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div id="rejectLeave" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="widget-content-area  data-widgets br-4">
                <div class="widget">
                    <div class="media" style="display:block">
                        <div class="icon ml-2" style="text-align: center;">
                            <i class="flaticon-cancel-2 text-danger" style="font-size: xxx-large;"></i>
                        </div>
                        <div style="text-align: center; margin-top: 10%;">
                            <b>Êtes-vous sûr de vouloir refuser la demande d'absence envoyée par {{selectedAbsence?.fullname}} du {{selectedAbsence?.start}}?</b>
                        </div>
                        <form [formGroup]="updateLeaveForm">
                            <div class="mt-4 mb-2 text-left">
                                <b>Raison du refus</b>
                            </div>
                            <textarea class="form-control pl-3 pr-3" formControlName="reject_reason"  rows="2" placeholder="Raison du refus"></textarea>
                        </form>
                        <div style="margin-top:5%">
                            <div class="mt-6 text-center">
                                <button class="btn btn-danger btn-rounded mb-0 mt-4 mr-2" (click)="update(selectedAbsence, 'reject')" 
                                    data-dismiss="modal">Refuser la demande</button>
                            </div>
                            <div class="mt-3 text-center">
                                <button class="btn btn-default btn-rounded mt-0 mb-0" data-dismiss="modal">Retour</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="acceptLeave" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="widget-content-area data-widgets br-4">
                <div class="widget">
                    <div class="media" style="display:block">
                        <div class="icon ml-2" style="text-align: center;">
                            <i class="flaticon-check text-success" style="font-size: xxx-large;"></i>
                        </div>
                        <div style="text-align: center; margin-top: 10%;">
                            <b>Êtes-vous sûr de vouloir accepter la demande d'absence envoyée par {{selectedAbsence?.fullname}} du {{selectedAbsence?.start}}?</b>
                        </div>
                        <form [formGroup]="updateLeaveForm">
                            <div class="mt-4 mb-2 text-left">
                                <b>Raison de l'acceptation</b>
                            </div>
                            <textarea class="form-control pl-3 pr-3" formControlName="accept_reason"  rows="2" placeholder="Raison de l'acceptation"></textarea>
                        </form>
                        <div style="margin-top:5%">
                            <div class="mt-6 text-center">
                                <button class="btn btn-success btn-rounded mb-0 mt-4 mr-2" (click)="update(selectedAbsence, 'accept')" 
                                    data-dismiss="modal">Accepter la demande</button>
                            </div>
                            <div class="mt-3 text-center">
                                <button class="btn btn-default btn-rounded mt-0 mb-0" data-dismiss="modal" (click)="updateLeaveForm.reset()">Retour</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


